import { Box, Link, Stack, Typography } from '@mui/material';
import Snackbar from 'components/shared/snackbar/SnackBar';
import { format } from 'date-fns';
import { forwardRef } from 'react';
import { fromLocalToUTC } from 'utils/date';

const formatDateRange = (scheduledFor, scheduledUntil) => {
  const start = fromLocalToUTC(new Date(scheduledFor));
  const end = fromLocalToUTC(new Date(scheduledUntil));

  return `${format(start, 'd MMM')} from ${format(start, 'HH:mm')} to ${format(end, 'HH:mm')} UTC`;
};

const MaintenanceSnackBar = forwardRef(({ event, ...props }, ref) => (
  <Snackbar
    ref={ref}
    {...props}
    title={event.name}
    variant="custom"
    message={
      <Stack spacing={0.5}>
        <Typography variant="caption">{formatDateRange(event.scheduledFor, event.scheduledUntil)}</Typography>
        <Link component={'a'} target="_blank" underline="always" href={event.shortlink}>
          View latest updates
        </Link>
      </Stack>
    }
  />
));

export default MaintenanceSnackBar;
